var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "sidebar-group",
    class: [{
      collapsable: _vm.collapsable,
      'is-sub-group': _vm.depth !== 0
    }, `depth-${_vm.depth}`]
  }, [_vm.item.path ? _c('router-link', {
    staticClass: "sidebar-heading clickable",
    class: {
      open: _vm.open,
      active: _vm.isActive(_vm.$route, _vm.item.path)
    },
    attrs: {
      "to": _vm.item.path
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.$emit('toggle');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _vm.collapsable ? _c('span', {
    staticClass: "arrow",
    class: _vm.open ? 'down' : 'right'
  }) : _vm._e()]) : _c('p', {
    staticClass: "sidebar-heading",
    class: {
      open: _vm.open
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('toggle');
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _vm.collapsable ? _c('span', {
    staticClass: "arrow",
    class: _vm.open ? 'down' : 'right'
  }) : _vm._e()]), _vm._v(" "), _c('DropdownTransition', [_vm.open || !_vm.collapsable ? _c('SidebarLinks', {
    staticClass: "sidebar-group-items",
    attrs: {
      "items": _vm.item.children,
      "sidebar-depth": _vm.item.sidebarDepth,
      "initial-open-group-index": _vm.item.initialOpenGroupIndex,
      "depth": _vm.depth + 1
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };